import React from "react";
import NewContent from "src/content/HomeContent/NewContent/NewContent";
import OldContent from "src/content/HomeContent/old-Content/Content";

const Test = () => {
  return <OldContent />;
};

export default Test;
